import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await axios.get("https://backend.maplecloudtechnologies.com:7443/reviews/pending");
      setReviews(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      const res = await axios.put(
        `https://backend.maplecloudtechnologies.com:7443/reviews/update/status/${id}/${status}`,
        {},
        { withCredentials: true }
      );

      if (res.status === 200) {
        toast.success("Review Approved !");
        fetchReviews();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="bg-[#0F172A] min-h-screen px-8 pt-20 pb-5 text-white">
      <Toaster position="top-right" reverseOrder={false} />

      <h2 className="text-3xl font-semibold mb-6 text-gray-100">
        Submitted Reviews
      </h2>

      {reviews.length > 0 ? (
        <div className="grid gap-6">
          {reviews.map((r) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-[#1E293B] rounded-xl shadow-xl p-6 border border-gray-700"
            >
              {/* Header */}
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-lg font-bold text-white">{r.name}</h3>
                  <p className="text-sm text-gray-400">{r.email}</p>
                </div>

                <div className="flex items-center gap-2">
                  <span
                    onClick={() => updateStatus(r.id, "Approved")}
                    className={`px-2 cursor-pointer  py-1 text-xs rounded-md font-medium bg-green-500/20 text-green-400`}
                  >
                    APPROVE
                  </span>
                  <span
                    onClick={() => updateStatus(r.id, "Rejected")}
                    className={`px-2 cursor-pointer  py-1 text-xs rounded-md font-medium bg-red-500/20 text-red-400`}
                  >
                    REJECT
                  </span>
                </div>
              </div>

              {/* Review */}
              <p className="mt-1 text-gray-300 leading-relaxed">{r.review}</p>

              {/* Rating */}
              <div className="flex gap-1 mt-2">
                {Array.from({ length: r.rating }, (_, i) => (
                  <span key={i} className="text-yellow-400 text-lg">
                    ★
                  </span>
                ))}
              </div>

              {/* Contact Info */}
              <div className="mt-2 text-sm text-gray-400">
                Phone: {r.phone} · Organization: {r.organization}
              </div>
            </motion.div>
          ))}
        </div>
      ) : (
        <div className="text-center">No Reviews...</div>
      )}
    </div>
  );
};

export default Reviews;
